// extracted by mini-css-extract-plugin
export default {"botao":"customStep_botao__5PV+U","container":"customStep_container__MIuGU"};